(function () {
  function initCarousel(carousel) {
    var track = carousel.querySelector('[data-mc-track]');
    var prevBtn = carousel.querySelector('[data-mc-prev]');
    var nextBtn = carousel.querySelector('[data-mc-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function scrollStep() {
      var card = track.querySelector('.mc-card');
      if (!card) return track.offsetWidth;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.offsetWidth;
      prevBtn.classList.toggle('mc-arrow--dim', track.scrollLeft < 2);
      nextBtn.classList.toggle('mc-arrow--dim', track.scrollLeft >= maxScroll - 2);
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });

    updateArrows();
  }

  document.querySelectorAll('[data-mc-carousel]').forEach(initCarousel);
})();
